import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';

import '../styles/Sidebar.css';
import {
  FaHome, FaFileAlt, FaQuestionCircle,
  FaChevronDown, FaChevronRight, FaBars, FaSignOutAlt
} from 'react-icons/fa';

import logo from '../assets/tifl.png';

const Sidebar = ({ activeItem, setActiveItem, isSidebarOpen, setIsSidebarOpen }) => {
  const [isPaperOpen, setIsPaperOpen] = useState(false);
  const [isQuestionOpen, setIsQuestionOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setIsPaperOpen(location.pathname.startsWith('/papers'));
    setIsQuestionOpen(location.pathname.startsWith('/questions'));
  }, [location.pathname]);

  // 🔐 Logout Function
    const handleLogout = async () => {
        try {
            const token = localStorage.getItem('token'); 
            
            await axios.post(
            'https://digital.tifleducation.com/admin/public/api/logout',
            {},
            {
                headers: {
                Authorization: `Bearer ${token}`,
                },
            }
            );

            localStorage.clear();
            sessionStorage.clear();

            navigate('/', { state: { logoutSuccess: true } });
        } catch (error) {
            console.error('Logout failed:', error.response || error);
            toast.error('Failed to logout. Please try again.');
        }
    };

  return (
    <>
      {/* Mobile Top Bar */}
      <div className="mobile-header">
        <a href="/dashboard">
        <img src={logo} alt="Logo" className="mobile-logo" />
        </a>
        <FaBars className="hamburger-icon" onClick={() => setIsSidebarOpen(!isSidebarOpen)} />
      </div>

      <aside className={`sidebar ${isSidebarOpen ? 'show' : ''}`}>
        <div className="dashlogo desktop-only">
          <a href="/dashboard">
          <img src={logo} alt="Logo" className="dashboard-logo" />
          </a>
        </div>

        <div className="sidebar-content">
          <nav className="menu">
            <Link
              to="/dashboard"
              className={`menu-item ${activeItem === 'dashboard' ? 'active' : ''}`}
              onClick={() => setActiveItem('dashboard')}
            >
              <FaHome />
              Dashboard
            </Link>

            {/* Papers */}
            <div className="menu-group">
              <Link
                to="/papers"
                className={`menu-item ${activeItem === 'papers' ? 'active' : ''}`}
                onClick={() => setActiveItem('papers')}
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <FaFileAlt />
                  Papers
                </div>
                {isPaperOpen ? <FaChevronDown /> : <FaChevronRight />}
              </Link>

              {isPaperOpen && (
                <div className="submenu">
                  <Link
                    to="/papers/prebuild"
                    className={activeItem === '/papers/prebuild' ? 'active' : ''}
                    onClick={() => setActiveItem('/papers/prebuild')}
                  >
                    <FaChevronDown /> Pre-Build Papers
                  </Link>
                  <Link
                    to="/papers/mypapers"
                    className={activeItem === '/papers/mypapers' ? 'active' : ''}
                    onClick={() => setActiveItem('/papers/mypapers')}
                  >
                    <FaChevronDown /> My Papers
                  </Link>
                   <Link
                    to="/papers/draftpaper"
                    className={activeItem === '/papers/draftpaper' ? 'active' : ''}
                    onClick={() => setActiveItem('/papers/draftpaper')}
                  >
                    <FaChevronDown /> Draft Papers
                  </Link>
                </div>
              )}
            </div>

            {/* Questions */}
            <div className="menu-group">
              <Link
                to="/questions"
                className={`menu-item ${activeItem === 'questions' ? 'active' : ''}`}
                onClick={() => setActiveItem('questions')}
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <FaQuestionCircle />
                  Questions
                </div>
                {isQuestionOpen ? <FaChevronDown /> : <FaChevronRight />}
              </Link>

              {isQuestionOpen && (
                <div className="submenu">
                  <Link
                    to="/questions/createque"
                    className={activeItem === '/questions/createque' ? 'active' : ''}
                    onClick={() => setActiveItem('/questions/createque')}
                  >
                    <FaChevronDown /> Create Questions
                  </Link>
                  <Link
                    to="/questions/myquestions"
                    className={activeItem === '/questions/myquestions' ? 'active' : ''}
                    onClick={() => setActiveItem('/questions/myquestions')}
                  >
                    <FaChevronDown /> My Questions
                  </Link>
                </div>
              )}
            </div>
          </nav>

          {/* 🔒 Logout at bottom */}
          <div className="logout-section">
            <button className="menu-item logout-btn" onClick={handleLogout}>
              <FaSignOutAlt />
              Logout
            </button>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
